// Шлюз «стиль карты разобран». Нужен вместо прямой проверки isStyleLoaded().
//
// У MapLibre `map.isStyleLoaded()` — это НЕ «стиль разобран», а «в стиле нет
// незавершённых загрузок»: он возвращает false, пока хоть один source не
// докачал тайлы. Классический страж
//
//     if (map.isStyleLoaded()) apply(); else map.once('load', apply)
//
// поэтому теряет обновления: событие `load` одноразовое, и если оно уже прошло,
// отложенный apply не выполнится НИКОГДА. На проде это выглядело так: слайдер
// дней двигал и фоновый растр течений, тот начинал качать тайлы, isStyleLoaded()
// становился false — и снос переставал перерисовываться, точки «замерзали».
//
// Правильный предикат — «стиль разобран» (после события `load`), а он одноразовый
// и монотонный: ровно то, что моделирует шлюз.
export interface StyleGate {
  /** Выполнить сразу, если стиль готов; иначе отложить до готовности. */
  run(fn: () => void): void
  /** Стиль разобран (событие `load`). Повторный вызов ничего не переигрывает. */
  markReady(): void
  readonly ready: boolean
}

export function createStyleGate(): StyleGate {
  let ready = false
  const queue: (() => void)[] = []

  return {
    get ready() {
      return ready
    },
    run(fn) {
      if (ready) fn()
      else queue.push(fn)
    },
    markReady() {
      if (ready) return
      ready = true
      // shift, а не forEach: вызов из очереди может добавить новый (см. тест).
      while (queue.length) queue.shift()!()
    },
  }
}
